// extracted by mini-css-extract-plugin
export default {"section-title":"title_section-title__omYmk","tooltip-container":"title_tooltip-container__oUawo"};